import { axiosInstance } from '../../utils';

interface Payload {
  id: string;
}

export const deleteDraft = async ({ id }: Payload): Promise<any> => {
  const res = await axiosInstance.delete(`/api/videos/delete-draft/${id}`);
  return res.data;
};
